// extracted by mini-css-extract-plugin
export default {"home":"c-i_cY","home__background":"c-i_cZ","home__content":"c-i_ea"};